import cn from '@integrations/classnames'
import type { ReactNode } from '@integrations/react'
import styles from './ContentWrapper.module.scss'

interface Props {
  children: ReactNode
  isLoggedIn?: boolean
}

function ContentWrapper({ children, isLoggedIn }: Props) {
  return (
    <div
      className={cn(styles['content-wrapper'], 'content-wrapper', {
        [styles['content-wrapper--authenticated']]: isLoggedIn,
        'content-wrapper--authenticated': isLoggedIn
      })}
    >
      {children}
      <div id='datepicker-portal'></div>
    </div>
  )
}

export default ContentWrapper
